// export const sendTestMatomoEvent = async (input, options = {}, url) => {
//   const action_name = typeof input === "string" ? input : input?.action_name;
//   const eventType = options.eventType || "event";

//   const eventCategory = input.eventCategory || "";
//   const eventAction = input.eventAction || "";
//   const eventName = input.eventName || "";

//   const c_i = options.c_i || "";
//   const c_p = options.c_p || "";
//   const c_t = options?.c_t || "";
//   const pubHouse = options.pubHouse || "0/Null";
//   // console.log(options,input, action_name, "Checkpubhouse");

//   // console.log("eventType", eventType, url);

//   const pageName = input?.url || "";
//   const getSourceContext = input?.sourceContext || "";
//   // console.log(getSourceContext,"getSourceContext")

//   function generateUUID() {
//     return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
//       /[xy]/g,
//       function (c) {
//         const r = (Math.random() * 16) | 0;
//         const v = c === "x" ? r : (r & 0x3) | 0x8; // version 4 UUID
//         return v.toString(16);
//       }
//     );
//   }

//   function calculateAge(dobString) {
//   if (!dobString) return null;
//   const today = new Date();
//   const dob = new Date(dobString);
//   let age = today.getFullYear() - dob.getFullYear();
//   const monthDiff = today.getMonth() - dob.getMonth();

//   // adjust if birthday hasn't happened yet this year
//   if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
//     age--;
//   }
//   return age;
// }


//   const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");
//   const age =  userDetails?.dob
//     ? calculateAge(userDetails.dob)  
//     : "Not Available";
//   // const mobileNumber = userDetails?.mobile || "Not Available";
//   const mobileNumber = localStorage.getItem("mobileNo") || "Not Available";
//   // const email = userDetails?.email || "Not Available";
//   const email = userDetails?.email || " ";
//   // const email = localStorage.getItem("mobileNo") || "Not Available";
//   let userType = "Guest User"; // Default

//   const webVersion = window.APP_VERSION;
//   const gender =
//     userDetails?.gender === 1
//       ? "Male"
//       : userDetails?.gender === 2
//       ? "Female"
//       : "Not Available";
//   const lang_id_name = localStorage.getItem("AppLanguage") || "Not Available";
//   const device_id = localStorage.getItem("macAddress_") || "Not Available";
//   const userId = userDetails?.id || localStorage.getItem("userID");
//   const profileId = localStorage.getItem("profileId");

//   const profile = JSON.parse(localStorage.getItem("myProfile"));

//   const type =
//     profile?.isKids === 0 || profile?.is_kid === 0
//       ? "Adult"
//       : profile?.isKids === 1 || profile?.is_kid === 1
//       ? "Child"
//       : "";

//   // console.log("testtttttt", type, "user", `${userId !== undefined ? userId : ""}${
//   //     profileId !== undefined && profileId !== null ? profileId : ""
//   //   }${type !== undefined && type !== null ? type : ""}`);

//   // console.log(localStorage.getItem("UserType"),userType,"Checking role")

//   // Get stored UUID or generate and store it
//   let storedUUID = localStorage.getItem("initialUUID");
//   if (!storedUUID) {
//     storedUUID = generateUUID();
//     localStorage.setItem("initialUUID", storedUUID);
//   }

//   // const hasProfile = profileId !== undefined && profileId !== null;
//   const hasProfile = localStorage.getItem("myProfile") ? true : false;
//   console.log("hasProfile", hasProfile);

//   const uid = hasProfile
//     ? `${userId || ""}_${profileId || ""}_${type || ""}`
//     : storedUUID;

//   const params = new URLSearchParams({
//     idsite: "1",
//     rec: "1",
//     action_name: action_name,
//     // _id: "123456789abcdef",

//     // uid: `${userId !== undefined ? userId : ""}_${
//     //   profileId !== undefined && profileId !== null ? profileId : ""
//     // }_${type !== undefined && type !== null ? type : ""}`,
//     uid: uid,
//     ua: navigator.userAgent,
//     dimension1: webVersion,
//     dimension2: age,
//     dimension3: gender,
//     dimension4: getSourceContext,
//     dimension5: lang_id_name,
//     dimension8: userType, // This send when user is not logged in
//     dimension10: device_id,
//     // dimension12: userType === "Guest User" ? generateUUID() : "",
//     url: `https://com.wavesOTT.samsung/${pageName}`,
//   });

//   if (hasProfile) {
//     params.append("dimension12", storedUUID);
//     const dimension7Value =
//       email && email.trim() !== "" && email !== " "
//         ? `${mobileNumber},${email}`
//         : mobileNumber;
//     params.append("dimension7", dimension7Value);
//     const isSubscribed = userDetails?.user_profiles?.[0].is_subscribe;
//     userType = isSubscribed === 1 ? "Paid User" : "Free User"; // Update userType based on subscription status
//     params.append("dimension8", userType); // Update dimension8 with the userType when user is logged in
//   }

//   if (eventType === "content_impression") {
//     params.append("c_n", action_name);
//     params.append("c_p", c_p);
//     params.append("c_t", "Impression");
//   }

//   if (eventType === "content_interaction") {
//     params.append("c_n", action_name);
//     params.append("c_p", c_p);
//     params.append("c_t", "");
//     params.append("c_i", c_i);
//     params.append("dimension6", pubHouse);
//   }

//   if (eventType === "event") {
//     params.append("e_c", eventCategory);
//     params.append("e_a", eventAction);
//     params.append("e_n", eventName);
//   }

//   if (eventType == "media_action") {
//     // unc trackMediaimpression(mediaTracker: MediaTrackingModel) {
//     // var params = [String:String]()
//     params.append("ma_id", options.mediaId || "");
//     params.append("ma_re", options.mediaUrl || "");
//     params.append("ma_mt", options.mediaType || "");
//     params.append("ma_ti", options.mediaTitle || "");
//     params.append("ma_pn", options.mediaPlayer || "");
//     params.append("ma_st", options.mediaInSecond || ""); //options.mediaInSecond || "")
//     params.append("ma_le", options.mediaLength || "");
//     params.append("ma_ps", options.mediaProgress || "");
//     //        params.append("ma_ttp",options.mediaPlayStartTime || "")
//     params.append("ma_w", options.mediaResolutionWidth || "");
//     params.append("ma_h", options.mediaResolutionHeight || "");
//     params.append("ma_fs", options.isinFullScreen || "");
//     params.append("ma_se", options.mediaPlaytime || "");
//     // let downloadURL = "https://builds.matomo.org/piwik.zip"
//     // let event = Event(tracker: MatomoTracker.shared, action: ["menu", "custom tracking parameters"], url: URL(string: downloadURL)!, customTrackingParameters: params, isCustomAction: true)
//     // MatomoTracker.shared.track(event)
//     // }
//     // params.append("c_n", action_name);
//     // params.append("c_p",c_p);
//     // params.append("c_t", c_t);
//     // params.append("c_i", c_i);
//   }

//   try {
//     const logUrl = localStorage.getItem("LogUrl");
//     const checkLogCapture = localStorage.getItem("LogCapture");

//     if (checkLogCapture !== "1" && !logUrl) {
//       console.log("first123");
//       return;
//     }

//     console.log(params.toString(), "params");

//     const response = await fetch(`${logUrl}?${params.toString()}`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     });

//     if (response.ok) {
//       console.log(`Matomo Test Event Sent Successfully`);
//     } else {
//       console.log("Matomo Tracking Failed:", response.status);
//     }
//   } catch (error) {
//     console.error("Error sending Matomo event:", error);
//   }
// };




export const sendTestMatomoEvent = async (input = {}, options = {}, urlOverride) => {


  // --- Helpers ---
  const safeGet = (key, fallback = "") => {
    try {
      const v = localStorage.getItem(key);
      return v === null ? fallback : v;
    } catch {
      return fallback;
    }
  };

  const safeParseJSON = (str, fallback = {}) => {
    try {
      return typeof str === "string" && str.trim() ? JSON.parse(str) : fallback;
    } catch {
      return fallback;
    }
  };

 function generateUUID() {
  return crypto.randomUUID();
}

  const calculateAge = dobString => {
    if (!dobString) return "";
    const dob = new Date(dobString);
    if (Number.isNaN(dob.getTime())) return "";
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) age--;
    return age >= 0 ? String(age) : "";
  };

  const appendIfHasValue = (params, key, value) => {
    if (value !== undefined && value !== null && value !== "" && value !== "Not Available") {
      params.append(key, String(value));
    }
  };

  // --- Read & cache localStorage once ---
  const userDetailsRaw = safeGet("user_details", "{}");
  const userDetails = safeParseJSON(userDetailsRaw, {});
  const myProfileRaw = safeGet("myProfile", "{}");
  const profile = safeParseJSON(myProfileRaw, {});
  const storedUUIDKey = "initialUUID";
  let initialUUID = safeGet(storedUUIDKey, "");
  if (!initialUUID) {
    initialUUID = generateUUID();
    try { localStorage.setItem(storedUUIDKey, initialUUID); } catch (e) {}
  }

  const mobileNumber = safeGet("mobileNo", "");
  const emailStored = (userDetails && userDetails.email) ? userDetails.email : "";
  const webVersion = window?.APP_VERSION || "";
  const lang_id_name = safeGet("AppLanguage", "");
  const device_id = safeGet("macAddress_", "");
  const userId = userDetails?.id ?? safeGet("userID", "");
  const profileId = profile?.profileId ?? safeGet("profileId"); // Always send current profile id
  const hasProfile = !!safeGet("myProfile", "");
  const gender =
    userDetails?.gender === 1 ? "Male" :
    userDetails?.gender === 2 ? "Female" : "Not available";

  const type =
    (profile?.isKids === 0 || profile?.is_kid === 0) ? "Adult" :
    (profile?.isKids === 1 || profile?.is_kid === 1) ? "Child" : "Not available";

  const age = calculateAge(userDetails?.dob);
  const pageName = input?.url || "";
  const getSourceContext = input?.sourceContext || "";

  // default values from inputs
  const action_name = typeof input === "string" ? input : input?.action_name || "";
  const eventType = (options.eventType || "event").toString();
  const eventCategory = input?.eventCategory || "";
  const eventAction = input?.eventAction || "";
  const eventName = input?.eventName || "";
  const c_i = options.c_i || "";
  const c_p = options.c_p || "";
  const c_t = options.c_t || "";
  const pubHouse = options.pubHouse || "";
  const DEVICE_MAP = {
  8: "lg",
  9: "samsung",
  11: "vida",
};
const deviceName = DEVICE_MAP[window.DEVICE_TYPE] ?? "unknown";

  // --- UID logic: if profile exists use userId_profileId_type, otherwise use initialUUID ---
  const uid = hasProfile
    ? `${userId || ""}_${profileId || ""}_${type || ""}`
    : initialUUID;

    console.log(uid,"uid - ",userId,"userId - ",profileId, "- profileId","checkingUid")

  // --- Build params ---
  const params = new URLSearchParams();
  // base required Matomo params
  params.append("idsite", "1");
  params.append("rec", "1");
  appendIfHasValue(params, "action_name", action_name);

  appendIfHasValue(params, "uid", uid);
  appendIfHasValue(params, "ua", navigator?.userAgent || "");
  appendIfHasValue(params, "dimension1", webVersion);
  appendIfHasValue(params, "dimension4", getSourceContext);
  appendIfHasValue(params, "dimension5", lang_id_name);
  appendIfHasValue(params, "dimension10", device_id);
  appendIfHasValue(params, "url", `https://com.wavesOTT.${deviceName}/${pageName}`);

  // Only attach profile-specific dimensions when hasProfile === true
  if (hasProfile) {
    appendIfHasValue(params, "dimension12", initialUUID); // keep initialUUID tracked server-side as separate dimension
    const dimension7Value = emailStored?.trim() ? `${mobileNumber || ""},${emailStored}` : (mobileNumber || "");
    appendIfHasValue(params, "dimension7", dimension7Value);
    const isSubscribed = userDetails?.user_profiles?.[0]?.is_subscribe;
    const userType = isSubscribed === 1 ? "Paid User" : "Free User";
    appendIfHasValue(params, "dimension2", age);
    appendIfHasValue(params, "dimension8", userType);
   appendIfHasValue(params, "dimension3", gender);

  } else {
    // guest user: set dimension8 as Guest User when no profile
    appendIfHasValue(params, "dimension8", "Guest User");
  }

  // --- Use switch for event types ---
  switch (eventType) {
    case "content_impression":
      appendIfHasValue(params, "c_n", action_name);
      appendIfHasValue(params, "c_p", c_p);
      appendIfHasValue(params, "c_t", "Impression");
      break;

    case "content_interaction":
      appendIfHasValue(params, "c_n", action_name);
      appendIfHasValue(params, "c_p", c_p);
      appendIfHasValue(params, "c_t", c_t);
      appendIfHasValue(params, "c_i", c_i);
      appendIfHasValue(params, "dimension6", pubHouse);
      break;

    case "media_action": {
      // map media options only when present
      appendIfHasValue(params, "ma_id", options.mediaId);
      appendIfHasValue(params, "ma_re", options.mediaUrl);
      appendIfHasValue(params, "ma_mt", options.mediaType);
      appendIfHasValue(params, "ma_ti", options.mediaTitle);
      appendIfHasValue(params, "ma_pn", options.mediaPlayer);
      appendIfHasValue(params, "ma_st", options.mediaInSecond);
      appendIfHasValue(params, "ma_le", options.mediaLength);
      appendIfHasValue(params, "ma_ps", options.mediaProgress);
      appendIfHasValue(params, "ma_w", options.mediaResolutionWidth);
      appendIfHasValue(params, "ma_h", options.mediaResolutionHeight);
      appendIfHasValue(params, "ma_fs", options.isinFullScreen);
      appendIfHasValue(params, "ma_se", options.mediaPlaytime);
      break;
    }

    case "event":
    default:
      // default to basic event tracking
      appendIfHasValue(params, "e_c", eventCategory);
      appendIfHasValue(params, "e_a", eventAction);
      appendIfHasValue(params, "e_n", eventName);
      break;
  }

  // --- Validate logging endpoint & capture flag early ---
  const logUrl = safeGet("LogUrl", "") || urlOverride || "";
  const checkLogCapture = safeGet("LogCapture", "");

  if (checkLogCapture !== "1" && !logUrl) {
    // Nothing to send; silently return false indicating not sent
    console.log("Matomo: logging disabled or LogUrl not provided");
    return { sent: false, reason: "logging_disabled_or_missing_url" };
  }

  try {
    const sendUrl = `${logUrl}?${params.toString()}`;
    const response = await fetch(sendUrl, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });

    if (!response.ok) {
      console.error("Matomo Tracking Failed:", response.status, response.statusText);
      return { sent: false, status: response.status, statusText: response.statusText };
    }

    console.log("Matomo Test Event Sent Successfully");
    return { sent: true, status: response.status };
  } catch (error) {
    console.error("Error sending Matomo event:", error);
    return { sent: false, error: error?.message || String(error) };
  }
};
